import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';

const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    const theme = useTheme();
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={20} textAnchor="end" fill={theme.palette.text.primary} transform="rotate(-35)">
                {payload.value}
            </text>
        </g>
    );
};


function RoomNightSalesComparisonMonthly({ data, colors }) {
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));

    const months = data.length > 0 ? data[0].data.map(d => d.month) : [];

    const chartData = data.map(d => {
        const entry = { name: d.name };
        d.data.forEach(item => {
            entry[item.month] = item.count;
        });
        return entry;
    });

    const barColors = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

    return (
        <Box backgroundColor={colors.primary[400]} p="20px">
            <Typography variant="h5">
                ROOM NIGHT SALES COMPARISON
            </Typography>
            <Typography variant="h4" fontWeight="600" textTransform={"uppercase"}>
                WITH PREVIOUS MONTHS
            </Typography>
            {data?.length ? (
                <Box
                    width={"100%"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={1}
                >
                    <ResponsiveContainer width={smScreen ? "100%" : "100%"} height={400}>
                        <BarChart
                            data={chartData}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 70,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" interval={0} height={60} tick={<CustomizedAxisTick/>}/>
                            <YAxis />
                            <Tooltip />
                            <Legend verticalAlign="top" wrapperStyle={{ paddingBottom: '20px' }}/>
                            {months.map((month, index) => (
                                <Bar key={month} dataKey={month} fill={barColors[index % barColors.length]}>
                                    <LabelList dataKey={month} position="top" style={{ fill: 'white', fontSize: "small" }} />
                                </Bar>
                            ))}
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <Typography mt={15} mb={15} textAlign="center">
                    No Data Available...
                </Typography>
            )}
        </Box>
    )
}

export default RoomNightSalesComparisonMonthly;